import { render, staticRenderFns } from "./sign-detail.vue?vue&type=template&id=a5aaf21a&scoped=true"
import script from "./sign-detail.vue?vue&type=script&lang=js"
export * from "./sign-detail.vue?vue&type=script&lang=js"
import style0 from "./sign-detail.vue?vue&type=style&index=0&id=a5aaf21a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5aaf21a",
  null
  
)

export default component.exports